import {
  AUTH_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  AUTH_HEADER_SCHEME,
} from '@/shared/constants/auth'
import { getSecureItem, setSecureItem } from '@/shared/lib/storage'

export async function refreshAccessToken(): Promise<string> {
  const refreshToken = await getSecureItem(REFRESH_TOKEN_KEY)
  if (!refreshToken) return ''

  try {
    const baseUrl = process.env.BUN_PUBLIC_BETTER_AUTH_URL ?? ''
    const response = await fetch(`${baseUrl}/api/auth/token`, {
      method: 'GET',
      headers: { Authorization: `${AUTH_HEADER_SCHEME} ${refreshToken}` },
    })

    if (!response.ok) return ''

    const result = await response.json()
    if (result?.token) {
      // Session is still valid. Return the session token (not the JWT) because
      // the bearer plugin uses HMAC to validate tokens and cannot handle JWTs.
      await setSecureItem(AUTH_TOKEN_KEY, refreshToken)
      return refreshToken
    }
    return ''
  } catch {
    return ''
  }
}
